export const urlRegex = /https?:\/\/[a-z0-9/:%_+.,#?!@&=-]+/

export const emailRegex = /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
